export default __webpack_public_path__ + "static/media/owlet.bf4ff078.jpg";